// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPromotionTypeInfo {
  /** Тип продвижения **/
  promotionType: EPromotionType;
  /** Стоимость продвижения **/
  price: number;
  /** Выбран ли тип продвижения по умолчанию **/
  isSelected: boolean;
  /** Рекомендуется ли по умолчанию данный тип продвижения **/
  isRecommended: boolean;
  /** Услуга недостуна ли **/
  isDisabled: boolean;
  /** Причина недоступности **/
  unavailableReasonType?: EUnavailableReasonType;
  /** Jwt токен аукциона **/
  token: string;
  /** Идентификатор дифф. цены **/
  diffPriceId?: number;
  /** Идентификатор итерации дифф. цены **/
  diffPriceIterationId?: string;
  /** Глобальный идентификатор гранулы дифф. цены **/
  diffPriceGranuleGuid?: string;
}
export enum EPromotionType {
  /** Без продвижения **/
  'NoPromotion' = 'noPromotion',
  /** Стандарт **/
  'Standard' = 'standard',
  /** Премиум **/
  'Premium' = 'premium',
  /** Топ **/
  'Top' = 'top',
}
export enum EUnavailableReasonType {
  /** Для ТОП-3 нужны фото **/
  'NoPhotos' = 'noPhotos',
  /** Не выполнены условия необходимые для размещения объявлений в ТОП 3 **/
  'Top3ServiceDenied' = 'top3ServiceDenied',
  /** Возможность продвижения объявлений для Вашего аккаунта заблокирована администрацией **/
  'DeniedBySanctions' = 'deniedBySanctions',
  /** Доступно после окончания периода публикации Премиум **/
  'OnlyAfterPremiumServiceExpiration' = 'onlyAfterPremiumServiceExpiration',
  /** Нет доступных услуг **/
  'NoServicesAvailable' = 'noServicesAvailable',
  /** Недостаточно денег **/
  'NotEnoughMoney' = 'notEnoughMoney',
  /** Возможность создания бесплатных объявлений для Вашего аккаунта заблокирована администрацией **/
  'FreeServiceDenied' = 'freeServiceDenied',
  /** Возможность создания объявлений с выделением цветом для Вашего аккаунта заблокирована администрацией **/
  'HighlightServiceDenied' = 'highlightServiceDenied',
  /** Недостаточно средств для оплату у агентства **/
  'NotEnoughMoneyOnAgencyAccount' = 'notEnoughMoneyOnAgencyAccount',
  /** Исчерпан лимит объявлений для субагента **/
  'SubAgentLimitExceeded' = 'subAgentLimitExceeded',
  /** Когда у субагента есть запрет на топ и премиум **/
  'DeniedByMaster' = 'deniedByMaster',
}
